export const CLASSPROGRESS_COLORS = {
  RED: "Red",
  YELLOW: "Yellow",
  GREEN: "Green",
};

export const CLASSPROGRESS_PRSCORE = {
  LOW: 25,
  HIGH: 75,
};
